import { useMediaPropsActive } from "./useMedia";
function useProps(props, opts) {
  return useMediaPropsActive(props, {
    expandShorthands: !(opts == null ? void 0 : opts.disableExpandShorthands)
  });
}
export {
  useProps
};
//# sourceMappingURL=useProps.js.map
